const {Template} = require('./ui.template.js');
const loadingBar = require('./ui.loadingBar.js');
const app = require('./app.js');
const {timeAgo, epochToClock} = require('./timeAgo.js');

class albumView extends Template{
    init(e){
        this.container = document.querySelector('#albumView');
        this.data = e.data;
        this.frames = e.frames;
        this.apps = {};
        console.log(e)
        const self = this;
        this.container.querySelector('.icon-arrow-left').onclick = function(){
            self.close();
        };

        this.hadnleKeydown = this.hadnleKeydown.bind(this);
        this.fillData();
        this.show();
    }

    fillData(){
        const items = this.container.querySelectorAll('[data-item]');
        for(let item of items){
            const key = item.dataset.item;
            if(key == 'timeAgo') item.innerHTML = timeAgo(this.data['time']);
            if(this.data[key]) item.innerHTML = this.data[key];
        }

        //in each frames take the `time` and add a timetoclock to the element
        for(let frame of this.frames){
            if(frame.time)
                frame.epochToClock = epochToClock(frame.time);

            frame.package = frame.app.package;
            if(!this.apps[frame.package]){
                this.apps[frame.package] = frame.app;
                this.inject('app-albumView_app', frame.app, document.getElementById('albumView_apps'), document.getElementById('albumView_filter_items'), false, this.filterApp);
            }
        }


        this.injectAllData(this.frames, document.querySelector('#albumView .album-contents'), document.getElementById('albumView_items'), 'album-frame-item animate', ()=>{console.log('click')});

    }

    addFrames(frameData){
        this.frames = this.frames.push(...frameData);
        this.fillData();
    }

    filterApp(app){
        const filterItem = document.querySelector('.app-filter[data-package="'+app.package+'"]');
        if(filterItem.classList.contains('active')){
            filterItem.classList.remove('active');
            document.querySelectorAll('#albumView .albumView-item[data-package="'+app.package+'"]').forEach((item) => {
              item.parentElement.classList.remove('fadeIn');  
              item.parentElement.classList.add('fadeOut');
            });
        }
        else{
            filterItem.classList.add('active');
            document.querySelectorAll('#albumView .albumView-item[data-package="'+app.package+'"]').forEach((item) => {
              item.parentElement.classList.remove('fadeOut');  
              item.parentElement.classList.add('fadeIn');
            });
        }
      }

    show(){
        loadingBar.hide();
        this.container.classList.add('show');
        setTimeout(() => {
            this.container.classList.remove('fadeInUp')
        },500)
        document.body.style.overflow = 'hidden';

        document.addEventListener('keydown', this.hadnleKeydown);
      }


      close(){
        this.container.classList.add('fadeOutDown');
        setTimeout(() => {
            this.container.classList.remove('show');
            this.container.classList.remove('fadeOutDown');
            this.container.classList.add('fadeInUp');
            document.body.style.overflow = '';
        },500)

        document.removeEventListener('keydown', this.hadnleKeydown);

        //remove all the frames and apps
        this.container.querySelector('.album-contents').innerHTML = '';
        this.container.querySelector('#albumView_apps').innerHTML = '';
      }

      hide = this.close

      hadnleKeydown(event){
        if(event.key == 'Escape'){
            this.close();
        }
    }
}


module.exports = albumView;
